
export function parseCsv (text = '', seperator = ',') {
    // to json format, list of dictionaries
    const rows = text.split(/\r?\n|\r/) || []
    
    // Parse headers with quote handling
    const parseRow = (line) => {
      const data = [];
      let inQuotes = false;
      let currentValue = '';
      
      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        
        if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === seperator && !inQuotes) {
          data.push(currentValue.trim());
          currentValue = '';
        } else {
          currentValue += char;
        }
      }
      
      // Push the last value
      data.push(currentValue.trim());
      return data;
    };
    
    const headers = parseRow(rows[0])
    
    // remove first array
    rows.shift()
    const body = rows
    const lines = []
  
    if (!body) {
      return []
    }
  
    body.forEach((line) => {
      if (!line || line.trim() === '') {
        return; // Skip empty lines
      }
      
      // Parse data with quote handling
      const data = parseRow(line);

      // default csv import with uuid field, will overwrite if it contains in csv
      // reason is for backend sentry parsing of unclear data format errors
      const row = {
        _meta: {
          headers,
          line
        }
      }
      
      headers.forEach((header, j) => {
        row[header] = data[j]
      })
      lines.push(row)

    })

    return lines
  }
  